import {Component, OnInit, EventEmitter} from '@angular/core';
import {CommonService} from "../common.service";
import {Router} from "@angular/router";
import {MaterializeAction} from 'angular2-materialize';
@Component({
  selector: 'app-certifiedfacilitator',
  templateUrl: './certifiedfacilitator.component.html',
  styleUrls: ['./certifiedfacilitator.component.css']
})
export class CertifiedfacilitatorComponent implements OnInit {
  masterApi: any;
  modalActions = new EventEmitter<string|MaterializeAction>();
  totalCampus: number = 0;
  campusInfocertificate: any;
  finalCampusArrcertified : any;
  AllCampusArrcertified = [];
  // campusArr:any[];
  constructor(public commonService: CommonService,private router: Router) {
  
    this.campusInfocertificate = this.commonService.getAuditInfo();
    this.campusInfocertificate.forEach((value: any) => {
      this.totalCampus = this.totalCampus + value['facilitators'].length;
    });
    this.masterApi = this.commonService.getMasterApi();
    console.log(this.commonService.getMasterApi())

    let campusArr = [];

    this.campusInfocertificate.forEach(function (result: any) {
      let subCampArr =  [];
      let name = [];
      result.facilitators.forEach(function (facilitators: any) {
        if(facilitators.audits){
          //console.log(facilitators.audits[0].auditData = {'dim001': 3, 'dim002': 3, 'dim003': 3, 'dim004': 3, 'dim005': 3 ,'dim006': 3 });
          var response = Object.values(facilitators.audits[facilitators.audits.length-1].auditData).filter(word => {
            //console.log(word);
            if(word == 3 ){
              return word;
            }
          })
          //console.log(response);
          if(Object.values(facilitators.audits[facilitators.audits.length-1].auditData).length == response.length){
            name.push(facilitators.name);
          }
        }
      });

      //subCampArr[] = name;
      campusArr.push(name);
    });
    this.finalCampusArrcertified = campusArr; //dynamic array

    let finalname = [];
    this.finalCampusArrcertified.forEach(function (result: any) {
      finalname = finalname.concat(result);
    });
    this.AllCampusArrcertified = finalname;

    console.log(this.AllCampusArrcertified); // first array
  }

  calculateData(campusInfo){

  }
  openModal() {
    this.modalActions.emit({action:"modal",params:['open']});
  }
  closeModal() {
    this.modalActions.emit({action:"modal",params:['close']});
  }
  ngOnInit() {
    console.log("hii");
  }

}



// WEBPACK FOOTER //
// /var/www/illumine/desktop/src/app/certifiedfacilitator/certifiedfacilitator.component.ts